import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-77">
      <div className="bg-brand-ivory border-2 border-brand-gold/30 p-4 rounded-xl text-center shadow-md" data-id="element-78">
        <p className="text-sm font-heading font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-79">
          VOTRE ACHAT EST ENTIÈREMENT PROTÉGÉ
        </p>
        <div className="w-12 h-12 mx-auto bg-brand-gold/15 rounded-full flex items-center justify-center mb-3" data-id="element-80">
          <ShieldCheckIcon className="w-6 h-6 text-brand-gold" data-id="element-81" />
        </div>
        <h3 className="text-xl sm:text-2xl font-heading font-extrabold text-brand-navy mb-2 uppercase leading-tight" data-id="element-82">
          🛡️ Garantie satisfait ou remboursé pendant 7 jours
        </h3>
        <div className="text-sm sm:text-base text-brand-text font-medium leading-snug space-y-2" data-id="element-83">
          <p data-id="element-84">Votre achat est totalement sans risque.</p>
          <p data-id="element-85">
            Prenez 7 jours pour découvrir l'ensemble du système, explorer tous
            les modules, préparer vos premiers entraînements et utiliser
            immédiatement les ressources avec vos gymnastes.
          </p>
          <p data-id="element-86">
            Si, pour une quelconque raison, vous n'êtes pas entièrement
            satisfait, contactez-nous simplement dans les 7 premiers jours et
            nous vous rembourserons 100 % de votre achat.
          </p>
          <p className="font-bold text-brand-navy" data-id="element-87">
            Aucun risque.
            <br data-id="element-88" />
            Aucune justification.
          </p>
        </div>
      </div>
    </section>;
}